import type {Callback, PS} from '@wix/document-services-types'
import _ from 'lodash'
import page from './page'
import tpaWidgetService from '../tpa/services/tpaWidgetService'

function removePage(ps: PS, tpaComps, _pageId: string, completeCallback: Callback) {
    _.forEach(tpaComps, tpaComp => tpaWidgetService.deleteWidget(ps, tpaComp))
    page.remove(ps, _pageId, completeCallback)
}

function validatePageRemoval(ps: PS, _pageId: string) {
    const widgetCompRefs = page.validatePageRemovalInternal(ps, _pageId)
    _.forEach(widgetCompRefs, widgetCompRef => tpaWidgetService.notifyBeforeWidgetDeleteInternal(ps, widgetCompRef))
    ps.setOperationsQueue.asyncPreDataManipulationComplete(widgetCompRefs)
}

export default {
    remove: removePage,
    validatePageRemoval
}
